import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { ReactTypeformEmbed } from 'react-typeform-embed';

import './PauseCancelMembership.css';

class PauseCancelMembership extends Component {
  handleClose = () => {
    browserHistory.replace('/reservations');
  }

  render() {
    return (
      <div className="PauseCancelMembership">
        <ReactTypeformEmbed
          popup
          autoOpen
          onClose={this.handleClose()}
          url="https://rype.typeform.com/to/wXKBlA"
          hideHeaders={false}
          hideFooter={false}
          style={{ top: 100 }}
          // @todo - Disabled for now, not clean
          // eslint-disable-next-line no-return-assign
          ref={(tf => this.typeformEmbed = tf)}
        />
      </div>
    );
  }
}

export default PauseCancelMembership;



// WEBPACK FOOTER //
// ./src/components/typeforms/PauseCancelMembership/PauseCancelMembership.js